import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
// import { REGISTRADO, EMITIDO, RECHAZADO, ANULADO } from '../../../common/types/comprobanteEstadoType';
import auth from '../../../common/utility/auth';

const REGISTRADO = 1;
const IMPORTADO = 2;
const ANULADO = 3;
const EMITIDO = 3;

export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idNotaVentaEstado === REGISTRADO)
            return 'blue';
        if (row.idNotaVentaEstado === IMPORTADO)
            return 'green';
        if (row.idNotaVentaEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="eye"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    disabled={row.idNotaVentaEstado === REGISTRADO ? true : false}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Copiar">
                                <Button
                                    type="primary"
                                    icon="copy"
                                    size={"small"}
                                    //disabled={ auth.user().idProducto==5?false:true}
                                    disabled={row.flagCredito}
                                    loading={props.loadingCopy}
                                    onClick={() => props.onCopy(row)}
                                />
                            </Tooltip>

                            {/*                       <Tooltip placement="top" title="Enviar correo">
                                <Button
                                    type="primary"
                                    icon="mail"
                                    size={"small"}
                                    disabled={row.idNotaVentaEstado !== ANULADO ? false : true}
                                    onClick={() => props.onCorreo(row)}
                                />
                            </Tooltip> */}
                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="close"
                                    size={"small"}
                                    disabled={(row.flagPagado || row.flagCredito) ? true : (row.idNotaVentaEstado === REGISTRADO ? false : true)}
                                    onClick={() => props.onAnular(row)}
                                />
                            </Tooltip>



                            {(row.idNotaVentaEstado == REGISTRADO && !row.flagPagado && !row.flagAprobado) ? (

                                <Tooltip placement="top" title="Editar">
                                    <Button
                                        type="primary"
                                        icon="edit"
                                        size={"small"}
                                        loading={props.loadingEdit}
                                        div={false}
                                        disabled={row.flagCredito}
                                        onClick={() => props.onEdit(row)}
                                    />
                                </Tooltip>


                            ) :
                                <Tooltip placement="top" title="Editar">
                                    <Button
                                        type="primary"
                                        icon="edit"
                                        size={"small"}
                                        loading={props.loadingEdit}
                                        disabled={true}
                                        onClick={() => props.onEdit(row)}
                                    />
                                </Tooltip>
                            }

                            <Tooltip placement="top" title="Aprobar">
                                <Button
                                    type="success"
                                    icon="check"
                                    size={"small"}
                                    disabled={(row.flagAprobado || row.idNotaVentaEstado == ANULADO ? true : false)}
                                    onClick={() => props.onAprobar(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    loading={props.loadingImprimir}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>

                        </div>
                    )
                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Cliente',
                    dataIndex: 'razonSocialCliente',
                    key: 'razonSocialCliente',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Vendedor',
                    dataIndex: 'vendedor',
                    key: 'vendedor',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Sub Total',
                    dataIndex: 'subTotal',
                    key: 'subTotal',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{value.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Igv',
                    dataIndex: 'igv',
                    key: 'igv',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{value.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Total',
                    dataIndex: 'total',
                    key: 'total',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreNotaVentaEstado',
                    key: 'nombreNotaVentaEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}